//#region IMPORT
import React, { useEffect, useState, useRef } from 'react';
import M_TBM_CUSTOM_06 from './M_TBM_CUSTOM_06';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useSave1 } from './M_TBM_CUSTOM_06_Query';
import { useSave } from '../../../../Hooks/useSave';
import useFileUpload from '../../../../Hooks/useFileUpload';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

function M_TBM_CUSTOM_06F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const userInfo = useSelector((state) => state?.BaseInfo?.userInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  const signatureCanvas = useRef(null);
  const [signInputs, setSignInputs] = useState({ mapUrl: '', mapFiles: {} });
  const signUpload = useFileUpload({
    oldFilePathField: 'signLocation',
    newFileNameField: 'saveName',
    getTargetPath: () => `TBM/${props.tbmCdRef?.current}/Sign`,
  });
  //#endregion

  // 스택형 뒤로가기로 변경: TBM 종료 전 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbmEnd' })),
  });

  //#region 이벤트
  useEffect(() => {
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
    };
  }, [dispatch]);
  //#endregion

  //#region 쿼리
  const { runAsync: Save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: 'M_TBM_CUSTOM_06',
    fileSave: async () => {
      const signFinalPath = await signUpload.SaveLogicFile();

      return { signLocation: signFinalPath };
    },
    saveData: () => ({ tbmCd: props.tbmCdRef.current }),
    requestSave: (rows) => Save1Async(rows),
    onSuccess: (rows) => {
      Complete();
      signUpload.clearFiles();
    },
  });
  //#endregion

  //#region 나머지 함수
  const Complete = () => {
    dispatch(CommonActions.setActiveStep(0));
    if (userInfo?.authCd === 'EMPLOYEE') {
      navigate('/M_PPE', { state: { tbmCd: props.tbmCdRef?.current } });
    } else {
      navigate('/Home');
    }
  };
  //#endregion

  return (
    <M_TBM_CUSTOM_06
      check={props.check}
      setCheck={props.setCheck}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      SaveLogic1={Save1}
      TbmEnd={props.TbmEnd}
      signatureCanvas={signatureCanvas}
      signInputs={signInputs}
      setSignInputs={setSignInputs}
      signUpload={signUpload}
    />
  );
}

export default M_TBM_CUSTOM_06F;
